import copy from "copy-to-clipboard"
import { useCallback, useState } from "react"

type CopiedValue = string | null
type CopyFn = (text: string) => Promise<boolean>

export function useCopyToClipboard(): [CopiedValue, CopyFn] {
  const [copiedText, setCopiedText] = useState<CopiedValue>(null)
  const [isError, setIsError] = useState(false)

  const copyFn: CopyFn = useCallback(async (text) => {
    try {
      const success = copy(text, {
        debug: process.env.NODE_ENV !== "production",
        message: "Copy to clipboard: #{key}, #{msg}",
      })

      if (success) {
        setCopiedText(text)
        setIsError(false)
        // Auto-reset
        setTimeout(() => setCopiedText(null), 2000)
        return true
      }
      setIsError(true)
      return false
    } catch (err) {
      console.error("Copy failed", err)
      setIsError(true)
      return false
    }
  }, [])

  return [copiedText, copyFn]
}

export default useCopyToClipboard
